import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

import { Grid, Column } from '../components/grid'
import { Icons, Icon } from './icon'
import { Header, Accent } from '../components/header'

const FooterGrid = styled.div`
    margin: 0.05rem;
    text-align: center;
    @media screen and (min-width: 980px) {
        text-align: left;
        display: grid;
        grid-gap: 0 2.25em;
        grid-template-columns: repeat(12, 1fr);
        margin: 0 auto;
        width: 90%;
    }
`
const FooterWrapper = styled.footer`
    padding: 2em 0 1em 0;
    text-align: center;
    background-color: ${props =>
        props.dark
            ? props.theme.bg_dark
            : props.theme.bg_light
    };
    color: ${props =>
        props.dark
            ? props.theme.font_light
            : props.theme.font_dark
    };
    font-family: ${props =>
        props.theme.font_body
    };

    .icons {
        margin: 0;
    }
    .copyright {
        text-align: left;
        font-size: 0.8em;
        list-style: none;
        margin: 0;
        padding: 0;

        li {
            margin: 0;
            text-align: left;
            border-left: none;
            display: inline-block;
            line-height: 1em;
            margin-left: 1em;
            padding: 0;

            &:first-child {
                margin: 0;
                text-align: left;
                border-left: 0;
                margin-left: 0;
                padding: 0;
            }
        }
    }
    .list {
        font-size: 0.8em;
        margin: 0 !important;
        padding: 0 !important;
        display: block;
        ul{
            li{
                a{
                    border-bottom: none !important; 
                }
            }
            font-size: 0.8em;
            margin: 0 !important;
            padding: 0 !important;
            display: block;
        }
        
    }
`

const Footer = (props) => (
    <FooterWrapper {...props}>
        <FooterGrid>
            {props.children.map(list =>
                <Column span='3'>
                    <div className='list'>
                        {list}
                    </div>
                </Column>
            )}
            <Column span='12'>
                <Icons>
                    <li><Icon href="https://twitter.com/membranlabs?lang=en" className='fab fa-twitter'></Icon></li>
                    <li><Icon href="https://www.instagram.com/membranlabs/" className="fab fa-instagram"></Icon></li>
                    <li><Icon href="https://www.linkedin.com/company/membran-entertainment-group/" className="fab fa-linkedin"></Icon></li>
                    <li><Icon href='mailto:canada@membran.net' className="fas fa-envelope"></Icon></li>
                </Icons>
            </Column>
            <Column span='12'>
                <div id='copyright'>
                    <ul style={{ listStyle: 'none', textAlign: 'center' }} className="copyright">
                        <p>&copy; Membran Entertainment Canada</p>
                    </ul>
                </div>
            </Column>
        </FooterGrid>
    </FooterWrapper >
)


export { Footer }


// WEBPACK FOOTER //
// ./src/components/footer.js